import axios from 'axios';

const BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) || 'http://localhost:3000';

/**
 * Shared axios instance.
 *
 * We deliberately do NOT set a default `Content-Type: application/json`
 * header here. Axios 1.x auto-derives the Content-Type from the request
 * body:
 *   - plain object  → `application/json`
 *   - FormData      → `multipart/form-data; boundary=…` (boundary included)
 *   - string        → `application/x-www-form-urlencoded`
 *
 * A hardcoded default would WIN over that auto-detection, which silently
 * breaks file uploads: the backend's Multer middleware skips the body
 * because the content-type isn't multipart, then the route returns
 * `400 file is required`. We saw this exact bug on /api/data-sources/upload —
 * the file was selected, axios sent JSON content-type, backend dropped
 * the body. Don't re-add the default.
 */
export const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

export interface GeoHint {
  country: string | null;
  city: string | null;
  /** Best-effort base language subtag from Accept-Language (e.g. "ja"), or null. */
  language: string | null;
  source: 'cloudflare' | 'none';
}

export async function getGeoHint(): Promise<GeoHint> {
  const r = await api.get<GeoHint>('/api/geo/hint');
  return r.data;
}
